// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__RtKHN","inputLabel":"styles_inputLabel__zL50n"};